document.addEventListener('DOMContentLoaded', () => {
  const menuDrawer = document.querySelector('.menu-drawer__menu');
  if (!menuDrawer) return;

  menuDrawer.addEventListener('click', (e) => {
    const openedDetails = e.target.closest('details.menu-drawer__item-details');
    if (!openedDetails) return;

    menuDrawer.querySelectorAll('details.menu-drawer__item-details[open]').forEach((details) => {
      if (details !== openedDetails) {
        details.removeAttribute('open');
      }
    });
  });
});